import { connect } from 'react-redux'
import userRolesSelector from './userRolesSelector'
import { sagaActions as rootSagaActions } from 'store/sagas'
import UserRoles from './UserRoles'

export default connect(
  userRolesSelector,
  {
    fetchUserRoles: rootSagaActions.fetchUserRoles,
    requestAddUserRole: rootSagaActions.requestAddUserRole,
    requestRemoveUserRole: rootSagaActions.requestRemoveUserRole,
  }
)(UserRoles)
